<template>
  <div>
    <section class="section-3 position-static d-flex flex-column justify-content-start align-items-center h-auto min-vh-100 w-100">
      <div class="content w-100">
        <div class="d-flex align-items-center justify-content-start mt-5 pl-5 w-100">
          <img src="../assets/images/logo.png" class="logo ml-5" alt="GBG Hamn">
        </div>
      </div>

      <div class="py-5" v-if="loading">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>

      <div class="container mt-5 text-white" v-else>
        <div class="row">
          <div class="col-12">
            <h1 class="text-uppercase m-0">{{ event.header }}</h1>
          </div>
          <div class="col-12 mb-5 mt-3">
            <event-player :event="event"></event-player>
          </div>
        </div>
      </div>
    </section>


    <main class="pb-5 mb-5" v-if="!loading && event && false">
      <section class="pt-5">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <h1 class="text-uppercase">{{ event.header }}</h1>
              <p class="h5" v-if="event.subHeader">{{ event.subHeader }}</p>
            </div>
          </div>
        </div>
      </section>

      <event-player :event="event" v-if="currentCode"></event-player>

      <section class="container">
        <div class="row" v-if="currentCode">
          <div class="col-12 mb-4" v-html="event.contentSignedIn"></div>
          <div class="col-12 mb-4" v-html="event.contentAgenda"></div>
        </div>
        <div class="row" v-else>
          <div class="col-12 py-4 text-center">
            <event-image :event="event"></event-image>
          </div>

          <div class="col-12 mb-4" v-html="event.contentDefault"></div>

          <div class="col-6">
            <p>To participate you have to enter the participation code you have received. The live event is available on most devices using modern web browsers. If you have any problems, please try another browser or device. Ad blockers should be turned off.</p>
          </div>
          
          <redeem-form :event="event" class="col-6"></redeem-form>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"

  import RedeemForm from "@/components/redeem-form.vue"
  import EventPlayer from "@/components/event-player.vue"
  import EventImage from "@/components/event-image.vue"

  export default {
    name: "home",
    components: { RedeemForm, EventPlayer, EventImage },
    props: {
      id: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        loading: true,
        sending: false,
        event: null,
        questionName: null,
        questionQuestion: null,
        questionThanks: null
      }
    },
    computed: {
      currentCode() {
        return this.$store.state.currentCode && this.$store.state.currentCode[this.event.id] && this.$store.state.currentCode[this.event.id].codeString
      },
      questionFormValid() {
        return !this.sending && 
          (this.questionName && this.questionName.length > 0) &&
          (this.questionQuestion && this.questionQuestion.length > 0)
      },
      ticketValid() {
        return ""
      }
    },
    methods: {
      async sendQuestion() {
        if(!this.questionFormValid) { return false }
        this.sending = true

        await firebase.firestore().collection(`questions`).add({
          name: this.questionName,
          question: this.questionQuestion,
          created: firebase.firestore.FieldValue.serverTimestamp()
        })

        this.questionQuestion = null
        this.questionThanks = "Thank you for your question. We will try to answer it!"
        this.sending = false

        setTimeout(() => {
          this.questionThanks = null
        }, 5000)
      }
    },
    async mounted() {
      await this.$bind("event", firebase.firestore().collection(`events`).doc(this.id))

      if(this.event && this.event.active) {
        this.loading = false
      } else {
        this.$router.replace({ name: "home" })
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>